import { type ReactNode, useState, useCallback, lazy, Suspense } from 'react';
import { IS_MODERN_BROWSER } from '@/utils/isModernBrowser';

const UnsupportedScreen = lazy(() => import('./UnsupportedScreen').then(m => ({ default: m.UnsupportedScreen })));

interface RuntimeGateProps {
  children: ReactNode;
}

/**
 * Wraps the entire application tree.
 * Modern browsers see children; legacy browsers see <UnsupportedScreen />.
 *
 * Uses the cached IS_MODERN_BROWSER constant — evaluated once
 * at module load, before React mounts, so there is zero flicker.
 *
 * Includes a soft escape hatch: users can bypass into "limited mode".
 */
export function RuntimeGate({ children }: RuntimeGateProps) {
  const [bypassed, setBypassed] = useState(false);

  const handleBypass = useCallback(() => {
    setBypassed(true);
  }, []);

  if (!IS_MODERN_BROWSER && !bypassed) {
    return (
      <Suspense fallback={null}>
        <UnsupportedScreen onBypass={handleBypass} />
      </Suspense>
    );
  }

  return <>{children}</>;
}
